const LurkerMetric = (eventType, objectDetail, rest = {}) => {
  const payload = {
    event_type: eventType,
    object_detail: objectDetail,
    ...rest,
  };

  if (process.env.isProd) {
    if (window && window.Lurker) {
      return window.Lurker.send(payload);
    }
  } else {
    /* eslint-disable no-console */
    console.log('[Lurker]');
  }

  return payload;
};

export default LurkerMetric;
